var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "male-signin-root", style: _vm.cssVars() },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `paddingTop:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.closeWeb },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow09.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.mybean.bonus"))),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm.signList && _vm.signList.length
        ? [
            _c("div", { staticClass: "male-signin-seven" }, [
              _c("div", { staticClass: "signin-seven-check" }),
              _c("div", { staticClass: "signin-seven-con" }, [
                _c("div", { staticClass: "sign-seven-tit" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k439"))),
                ]),
                _c(
                  "div",
                  { staticClass: "sign-seven-props" },
                  [
                    _vm._l(_vm.signList, function (item, index) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "sign-seven-item",
                            class: {
                              "item-on": !item.past,
                              "item-off": item.past,
                              "item-long":
                                index === _vm.signList.length - 1 &&
                                item.rewardDataList &&
                                item.rewardDataList.length === 2,
                              "current-on": item.ifCurDay,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "seven-item-block" },
                              _vm._l(item.rewardDataList, function (ele, idx) {
                                return _c(
                                  "div",
                                  { key: index },
                                  [
                                    _vm.propsMap[ele.rewardPropType]
                                      ? [
                                          item.past
                                            ? _c("img", {
                                                attrs: {
                                                  src: _vm.getMatchImg(
                                                    `${
                                                      _vm.propsMap[
                                                        ele.rewardPropType
                                                      ]
                                                    }-off`
                                                  ),
                                                },
                                              })
                                            : _c("img", {
                                                attrs: {
                                                  src: _vm.getMatchImg(
                                                    _vm.propsMap[
                                                      ele.rewardPropType
                                                    ]
                                                  ),
                                                },
                                              }),
                                        ]
                                      : _vm._e(),
                                    _c("span", [
                                      _vm._v(
                                        "x" +
                                          _vm._s(ele.rewardPropNumber || "?")
                                      ),
                                    ]),
                                  ],
                                  2
                                )
                              }),
                              0
                            ),
                            _c(
                              "div",
                              { staticClass: "seven-item-day" },
                              [
                                !item.ifCurDay && item.ifSigned
                                  ? _c("div", { staticClass: "got" })
                                  : [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("lang.sevenKeepSignin.day")
                                        ) + _vm._s(item.index)
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]
                        ),
                        _vm.signList[index + 1] && index !== 3
                          ? _c("div", { staticClass: "seven-gap" })
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
            ]),
            _vm.currentDay
              ? [
                  _vm.currentDay.ifSigned
                    ? _c("div", { staticClass: "sign-btn" }, [
                        _c("div", { staticClass: "sign-btn-icon" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("lang.commonM.k293")) +
                            " " +
                            _vm._s(_vm.countdownResult.hours) +
                            ":" +
                            _vm._s(_vm.countdownResult.minutes) +
                            ":" +
                            _vm._s(_vm.countdownResult.seconds) +
                            " "
                        ),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "sign-btn btn-on",
                          on: { click: _vm.handleSignIn },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("lang.sevenKeepSignin.signin")) +
                              " "
                          ),
                        ]
                      ),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.serviceAdvantageData && _vm.serviceAdvantageData.length
        ? _c(
            "div",
            { staticClass: "banner-swipe" },
            [
              _c(
                "swiper",
                {
                  staticClass: "swiper-root",
                  attrs: { options: _vm.swiperOptions },
                },
                _vm._l(_vm.serviceAdvantageData, function (item) {
                  return _c("swiper-slide", { key: item.id }, [
                    _c(
                      "div",
                      {
                        staticClass: "slide-item",
                        on: {
                          click: function ($event) {
                            return _vm.handleJumpPathFromBanner(item, "goUrl")
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm._f("imgPath")(item.content) },
                        }),
                      ]
                    ),
                  ])
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.newerTask && _vm.newerTask.length
        ? _c(
            "div",
            { staticClass: "task-block" },
            [
              _c("div", { staticClass: "task-bg" }),
              _c("div", { staticClass: "task-top" }, [
                _c("div", { staticClass: "task-head" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k441"))),
                ]),
                _vm.expries
                  ? _c("div", { staticClass: "task-tips" }, [
                      _vm._v(
                        _vm._s(_vm.$t("lang.commonM.k446")) +
                          " " +
                          _vm._s(_vm.expries)
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._l(_vm.newerTask, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "task-item",
                    attrs: { id: `beginner${item.eventId}` },
                  },
                  [
                    _c("div", { staticClass: "item-icon" }, [
                      _c("img", {
                        attrs: { src: _vm._f("imgPath")(item.icon) },
                      }),
                    ]),
                    _c("div", { staticClass: "item-con" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(item.title) + " (" + _vm._s(item.process) + ")"
                        ),
                      ]),
                      item.rewardType !== "?"
                        ? _c("div", [
                            _c("img", {
                              attrs: { src: _vm.getMatchImg(item.rewardType) },
                            }),
                            _vm._v("x" + _vm._s(item.rewardNum) + " "),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "item-btn-wrap" }, [
                      item.state === 0
                        ? _c(
                            "div",
                            {
                              staticClass: "item-btn start",
                              on: {
                                click: function ($event) {
                                  return _vm.handleJumpPath(item, "gotoUrl")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("lang.commonM.k442")) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      item.state === 1
                        ? _c(
                            "div",
                            {
                              staticClass: "item-btn claim",
                              on: {
                                click: function ($event) {
                                  return _vm.handleClaim(item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("lang.commonM.k073")) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      item.state === 2
                        ? _c("div", { staticClass: "item-btn got" }, [
                            _c("div"),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.dailyTask && _vm.dailyTask.length
        ? _c(
            "div",
            { staticClass: "task-block" },
            [
              _c("div", { staticClass: "task-bg" }),
              _c("div", { staticClass: "task-top" }, [
                _c("div", { staticClass: "task-head" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k225"))),
                ]),
                _c("div", { staticClass: "task-tips" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k440"))),
                ]),
              ]),
              _vm._l(_vm.dailyTask, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "task-item",
                    attrs: { id: `daily${item.eventId}` },
                  },
                  [
                    _c("div", { staticClass: "item-icon" }, [
                      _c("img", {
                        attrs: { src: _vm._f("imgPath")(item.icon) },
                      }),
                    ]),
                    _c("div", { staticClass: "item-con" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(item.title) + " (" + _vm._s(item.process) + ")"
                        ),
                      ]),
                      item.rewardType !== "?"
                        ? _c("div", [
                            _c("img", {
                              attrs: { src: _vm.getMatchImg(item.rewardType) },
                            }),
                            _vm._v("x" + _vm._s(item.rewardNum) + " "),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "item-btn-wrap" }, [
                      item.state === 0
                        ? _c(
                            "div",
                            {
                              staticClass: "item-btn start",
                              on: {
                                click: function ($event) {
                                  return _vm.handleJumpPath(item, "gotoUrl")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("lang.commonM.k442")) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      item.state === 1
                        ? _c(
                            "div",
                            {
                              staticClass: "item-btn claim",
                              on: {
                                click: function ($event) {
                                  return _vm.handleClaim(item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("lang.commonM.k073")) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      item.state === 2
                        ? _c("div", { staticClass: "item-btn got" }, [
                            _c("div"),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _c("div", { staticStyle: { height: "100px" } }),
      _vm.showReward
        ? _c("div", { staticClass: "mask" }, [
            _vm.showReward === 1
              ? _c("div", { staticClass: "dia-con reward1" }, [
                  _c("div", { staticClass: "dia-top" }, [
                    _c("div", { staticClass: "dia-tit" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k147")) + "!"),
                    ]),
                  ]),
                  _c("div", { staticClass: "reward-con" }, [
                    _vm.taskReward.rewardType !== "?"
                      ? _c("div", { staticClass: "reward-item" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.getMatchImg(_vm.taskReward.rewardType),
                              alt: "",
                            },
                          }),
                          _vm._v(
                            " x" + _vm._s(_vm.taskReward.rewardNum || "-") + " "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "dia-btn",
                      on: {
                        click: function ($event) {
                          _vm.showReward = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                  ),
                ])
              : _vm._e(),
            _vm.showReward === 2
              ? _c("div", { staticClass: "dia-con reward2" }, [
                  _c("div", { staticClass: "dia-top" }, [
                    _c("div", { staticClass: "dia-tit" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k085"))),
                    ]),
                    _c("p", { staticClass: "dia-tips" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k443"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "reward-con" },
                    _vm._l(_vm.signInReward, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "reward-item",
                          class: {
                            only:
                              _vm.signInReward && _vm.signInReward.length === 1,
                          },
                        },
                        [
                          item.rewardType !== "?"
                            ? _c("img", {
                                attrs: {
                                  src: _vm.getMatchImg(item.rewardType),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" x" + _vm._s(item.rewardNum) + " "),
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "dia-btn",
                      on: {
                        click: function ($event) {
                          _vm.showReward = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "dia-bottom",
                      on: { click: _vm.handleRemind },
                    },
                    [
                      _c("div", {
                        staticClass: "switch-block",
                        class: { on: _vm.remindStatus, off: !_vm.remindStatus },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k444")))]),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }